import { X, Check } from "lucide-react";
import { Reveal, Chapter } from "@/components/site/Reveal";
import { DIFFERENCE_ROWS } from "@/data/content";

export default function Difference() {
  return (
    <section id="difference" className="bg-ivory text-slateink">
      <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Chapter n="Chapter 03" label="The VERIVISTA Difference" />
        <Reveal>
          <h2 className="max-w-3xl text-balance font-serif text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Fragmented bookkeeping, or integrated sovereignty.
          </h2>
        </Reveal>

        <div data-testid="difference-matrix" className="mt-16 grid overflow-hidden border border-slateink/15 lg:grid-cols-2">
          <div className="bg-parchment/60 p-8 sm:p-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-bodylight">The Traditional Way</p>
            <h3 className="mt-4 font-serif text-2xl font-medium">Fragmented Accounting</h3>
            <ul className="mt-10 space-y-7">
              {DIFFERENCE_ROWS.map(([bad], i) => (
                <Reveal key={bad} delay={0.08 * i}>
                  <li data-testid={`difference-item-${i + 1}`} className="flex items-start gap-4">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center border border-slateink/20 text-slateink/50">
                      <X size={13} strokeWidth={2} />
                    </span>
                    <span className="text-sm leading-relaxed text-bodylight sm:text-base">{bad}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          <div className="relative bg-ink p-8 text-ivory sm:p-12">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(197,160,89,0.12),transparent_55%)]" aria-hidden="true" />
            <p className="relative font-mono text-[11px] uppercase tracking-[0.28em] text-gold">The VERIVISTA Way</p>
            <h3 className="relative mt-4 font-serif text-2xl font-medium">Integrated Financial Sovereignty</h3>
            <ul className="relative mt-10 space-y-7">
              {DIFFERENCE_ROWS.map(([, good], i) => (
                <Reveal key={good} delay={0.08 * i}>
                  <li className="flex items-start gap-4">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center border border-gold/50 bg-gold/10 text-gold">
                      <Check size={13} strokeWidth={2.5} />
                    </span>
                    <span className="text-sm leading-relaxed text-ivory/85 sm:text-base">{good}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
